var imgSelected = true;
var inpFileOne1 = document.getElementById("inpBusinessImg");
var img1flag;
var BusinessImage;
var otp;
var newEditProductImages = [];
var inpFileOne1 = document.getElementById("inpBusinessImg");
var inpFileOne = document.getElementById("inpBusinessImgPreview1");
var vendorDocumentArray = [];
var businessImageArray = [];

import { getImageUrl } from "../helpers/mediaUrl";

export default class vendorServicing_profile {
  constructor() {
    this.basicDetailsAndAddressForm = $("#basicDetails-AddressForm1");
    this.inputBusinessName = $("#inputBusinessName");
    this.inputContactPersonName = $("#inputContactPersonName");
    this.inputPhoneNumber = $("#inputPhoneNumber");
    this.inputEmail1 = $("#inputEmail1");
    this.submitBtn = $("#editNamesubmitBtn");
    this.saveChangesBtn = $("#saveChangesBtn");
    this.businessNameError = $("#businessNameError");
    this.contactPersonNameError = $("#contactPersonNameError");
    this.phoneNumberError = $("#phoneNumberError");
    this.emailError = $("#emailError");
    this.BusinessImageError = $(".BusinessImageError");
    this.venId = $("#venId");
    this.verifyOtpModal = $("#verifyOtpModal");
    this.OTPInputVerify = $("#otp-input-verify");
    this.OTPSuccess = $("#otpError");
    this.verifyOTPDetails = $("#verify-edit-OTP-details");
    this.verifyOTPBtn = $("#verify-OTP-btn");
    this.resendOTPBtn = $("#resend-OTP-btn");
    this.stem2submitBtn = $("#stem2submitBtn");
    this.Products_Services_page4 = $(".Products-Services-page4");
    this.otpInputVerify = $("#otpInputVerify");
    this.otpError = $("#otpError");
    this.verifyOtpModalClose = $("#verifyOtpModalClose");
    this.upload_form = $("#upload_form");

    //new Variables
    this.profileImage1 = $("#inpBusinessImg");
    this.profileImage2 = $("#inpBusinessImg2");
    this.profileImage3 = $("#inpBusinessImg3");

    this.vendorProfileImg = $(".vendorProfileImg");

    this.formProfile = $("#basicDetails-AddressForm1");

    this.bindEvents();
  }

  bindEvents = () => {
    this.get_Vendor_Summary();

    globalThis.phnoEmailIsUnique = false;
    globalThis.userCreated = false;
    globalThis.prevPhoneNo = 0;
    globalThis.prevEmail = "old";

    this.submitBtn.on("click", this.doFormAction);
    this.verifyOTPBtn.on("click", this.doVerifyOTP);
    this.resendOTPBtn.on("click", this.doResendOTPAction);

    this.saveChangesBtn.on("click", this.closeModal);
    this.verifyOtpModalClose.on("click", this.closeOTPModal);

    // inpFileOne1.addEventListener("change", this.ImageValidate);
    this.vendorProfileImg.on("change", this.imageChangefn);

    // this.inputPhoneNumber.on("focus", this.prevScroll);//individual input

    this.formProfile.on("focus", "input[type=number]", function (e) {
      $(this).on("wheel.disableScroll", function (e) {
        //
        e.preventDefault();
      });
    });

    // Bind cropping action to profile images
    $(".vendorProfileImg").on("click", cropperMain.doCroppingAction);
  };

  //for individual input
  // prevScroll = (e) => {
  //    this.inputPhoneNumber.on('wheel.disableScroll', function (e) {
  //
  //       e.preventDefault()
  //     })

  //   // $('formProfile').on('blur', 'input[type=number]', function (e) {
  //   //

  //   //   $(this).off('wheel.disableScroll')
  //   // })
  //  };

  imageChangefn = (e) => {
    var imgInput = e.target.id;
    var imgPrev = e.target.defaultValue;
    var imgNumber = e.target.name;
    var imgError = "BusinessImageError" + imgNumber;

    const imgInputEle = document.getElementById(imgInput);
    const imgPrevEle = document.getElementById(imgPrev);
    const imgErrorEle = document.getElementById(imgError);

    var imgExpression = /.*\.(jpg|jpeg|png|JPG|JPEG|PNG)$/;
    if (!imgInputEle.files[0]) {
      imgPrevEle.src = "";

      // imgSelected = false;
    } else {
      if (!imgInputEle.files[0]["name"].match(imgExpression)) {
        // img1flag = false;
        // imgSelected = false;

        imgPrevEle.src = "";

        imgInputEle.value = "";
        imgErrorEle.innerHTML = "Please select an image file";
        imgErrorEle.value = 1;
      } else {
        imgErrorEle.innerHTML = "";
        imgErrorEle.value = 0;
      }
    }
  };

  ImageValidate = () => {
    const ImgError = document.getElementsByClassName("ImgError");
    for (var i = 0; i < ImgError.length; i++) {
      if (ImgError[i].value == 1) {
        alert("Current immages are not valid");
        return false;
      }
    }
    return true;
  };

  get_Vendor_Summary = () => {
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/getVendorDetails",
      headers: { Authorization: X_API_KEY },
      success: this.show_vendor_details,
    });
  };

  show_vendor_details = (res) => {
    // BusinessImage1 is stored in vendor_master.Image_URL
    businessImageArray[0] = getImageUrl(res.Image_URL);
    document.getElementById("inpBusinessImgPreview1").src =
      businessImageArray[0];

    // BusinessImage2/3 are stored in vendor_images table and returned as Vendor_Images
    const vendorImages = Array.isArray(res.Vendor_Images)
      ? res.Vendor_Images
      : [];
    vendorImages.forEach((img) => {
      if (!img || !img.Image_URL) return;
      const match = img.Image_URL.match(/BusinessImage([23])\.png$/);
      if (!match) return;
      const imageNo = parseInt(match[1], 10);
      const imageUrl = getImageUrl(img.Image_URL);
      businessImageArray[imageNo - 1] = imageUrl;
      document.getElementById("inpBusinessImgPreview" + imageNo).src = imageUrl;
    });

    document.getElementById("inputBusinessName").value = res.Business_Name;
    document.getElementById("inputContactPersonName").value =
      res.Contact_Person;
    document.getElementById("inputPhoneNumber").value = res.Phone_Number;
    document.getElementById("inputEmail1").value = res.Email_Address;

    prevPhoneNo = this.inputPhoneNumber.val();
    prevEmail = this.inputEmail1.val();
  };

  doFormAction = async (e) => {
    phnoEmailIsUnique = false;
    e.preventDefault();

    const inpFile = document.getElementById("inpBusinessImg");

    //let inputFileOneValue = inpFile.files[0];

    if (inpFile.files[0] === undefined) {
      // this.BusinessImageError.html("Please select an image");
      imgSelected = true;
      img1flag = 1;
    } else {
      this.ImageValidate();
    }

    // this.ImageValidate();
    if (imgSelected) {
      this.BusinessImageError.html("");
    } else {
      this.BusinessImageError.html("Please select an image.");
    }

    let isBusinessNameValidated = this.BusinessName_validate();
    if (isBusinessNameValidated) {
      this.businessNameError.html("");
    }

    let isContactPersonNameValidated = this.ContactPersonName_validate();
    if (isContactPersonNameValidated) {
      this.contactPersonNameError.html("");
    }

    let isPhValidated = this.Phno_validate();
    if (isPhValidated) {
      this.phoneNumberError.html("");
    } else {
    }

    let isEmailValidated = this.Email_validate();
    if (isEmailValidated) {
      this.emailError.html("");
    }

    if (true) {
      await this.phnoEmailIsUnique_validate();

      if (phnoEmailIsUnique) {
        this.emailError.html("");
        this.phoneNumberError.html("");
      }
    }

    if (
      isBusinessNameValidated &&
      isContactPersonNameValidated &&
      isPhValidated &&
      isEmailValidated &&
      phnoEmailIsUnique &&
      imgSelected &&
      this.ImageValidate()
    ) {
      $.ajax({
        type: "POST",
        url: baseURL + "api/Vendor/SendOTPSignUp",

        headers: { Authorization: X_API_KEY },

        data: this.basicDetailsAndAddressForm.serialize(),
        success: (data) => {
          otp = data["OTP"]; // Match backend field name (uppercase)
          console.log("OTP received:", otp);
          setTimeout(() => {
            this.OTPSuccess.addClass("text-danger");

            this.OTPSuccess.html("OTP has expired, Try again.");
            otp = null;
          }, 600000);
        },
        error: (err) => {},
      });
      this.OTPSuccess.html(" ");
      // this.otpInputVerify.val(" ");
      // this.verifyOtpModal.show();
      window.$("#verifyOtpModal").modal("show");
      // this.Submit_Form();
    }
  };

  closeModal = () => {
    this.autoDetectModal.hide();
  };

  closeOTPModal = () => {
    // this.verifyOtpModal.hide();
    window.$("#verifyOtpModal").modal("hide");

    // this.otpInputVerify.val(" ");
  };

  phnoEmailIsUnique_validate = async () => {
    if (
      prevPhoneNo == this.inputPhoneNumber.val() &&
      prevEmail == this.inputEmail1.val()
    ) {
      phnoEmailIsUnique = true;
    } else {
      await new Promise((resolve) => {
        $.ajax({
          type: "POST",
          url: baseURL + "api/Vendor/CheckPhNoEmailExists",

          headers: { Authorization: X_API_KEY },

          data: this.basicDetailsAndAddressForm.serialize(),
          statusCode: {
            400: function () {
              alert("400 status code! user error");
            },
            500: function () {
              alert("500 status code! server error");
            },
          },
          success: (res) => {
            this.CheckPhNoEmailExistsSuccess(res);
            resolve();
          },
          error: resolve,
        });
      });
    }
  };

  CheckPhNoEmailExistsSuccess = (res) => {
    let retCode = res.Code;

    if (retCode == 6) {
      this.phoneNumberError.html("Phone Number already exists");
      if (prevPhoneNo == this.inputPhoneNumber.val()) {
        phnoEmailIsUnique = true;
      } else {
        phnoEmailIsUnique = false;
      }
    }
    if (retCode == 7) {
      this.emailError.html("Email already exists");

      if (prevEmail == this.inputEmail1.val()) {
        phnoEmailIsUnique = true;
      } else {
        phnoEmailIsUnique = false;
      }
    }
    if (retCode == 8) {
      // this.emailError.html("Email and PhoneNo already exists");
      if (prevPhoneNo != this.inputPhoneNumber.val()) {
        this.phoneNumberError.html("Phone Number already exists");
      }
      if (prevEmail != this.inputEmail1.val()) {
        this.emailError.html("Email already exists");
      }
      if (
        prevPhoneNo == this.inputPhoneNumber.val() &&
        prevEmail == this.inputEmail1.val()
      ) {
        phnoEmailIsUnique = true;
      } else {
        phnoEmailIsUnique = false;
      }
    }
    if (retCode == 0) {
      // this.emailError.html("Email already exists");

      phnoEmailIsUnique = true;
    }
  };

  //validate function

  BusinessName_validate = () => {
    let flag = true;

    if (
      !(
        this.inputBusinessName.val().length >= 2 &&
        this.inputBusinessName.val().length <= 100
      )
    ) {
      this.businessNameError.html(
        "Business Name must be min 2 and max 100 characters",
      );

      flag = false;
    }

    return flag;
  };

  ContactPersonName_validate = () => {
    let flag = true;
    var contactname = /^[a-z ,.'-]+$/i;
    if (
      !(
        this.inputContactPersonName.val().length >= 2 &&
        this.inputContactPersonName.val().length <= 100
      ) ||
      !this.inputContactPersonName.val().match(contactname)
    ) {
      this.contactPersonNameError.html(
        "Contact Person Name must min 2 and max 100 characters",
      );

      flag = false;
    }

    return flag;
  };

  Phno_validate = () => {
    let flag = true;
    // var phoneno = /^\d{10}$/;
    var phoneno = /^[1-9]{1}[0-9]{9}$/;
    if (!this.inputPhoneNumber.val().match(phoneno)) {
      this.phoneNumberError.html(
        "Please enter only 10 digits for mobile number",
      );

      flag = false;
    }

    return flag;
  };

  Email_validate = () => {
    let flag = true;
    var emailexample =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!this.inputEmail1.val().match(emailexample)) {
      this.emailError.html("Please enter a valid email");

      flag = false;
    }

    return flag;
  };

  doVerifyOTP = (e) => {
    e.preventDefault();

    let isOTPValidated = this.verifyOTPFunction();
    if (isOTPValidated) {
      this.OTPSuccess.addClass("text-success");
      this.OTPSuccess.removeClass("text-danger");
      this.OTPSuccess.html("OTP sent ");
      this.OTPInputVerify.prop("disabled", true);
      this.verifyOTPBtn.addClass("d-none");
      this.verifyOTPDetails.addClass("d-none");
      this.submitBtn.removeClass("d-none");
      // this.verifyOtpModal.hide();
      window.$("#verifyOtpModal").modal("hide");

      // setTimeout(demo, 5000);
      this.Submit_Form();
    } else {
      this.OTPSuccess.addClass("text-danger");
      //this.OTPSuccess.removeClass("text-success");
      this.OTPSuccess.html("Invalid OTP");
    }
  };

  verifyOTPFunction = () => {
    let flag = true;
    let OTPExample = /^\d{4}$/;
    let userInput = this.otpInputVerify.val();

    if (!userInput.match(OTPExample)) {
      console.warn("OTP format invalid. Expected 4 digits, got:", userInput);
      flag = false;
    } else {
      // Convert both to strings for comparison
      let otpStr = String(otp).trim();
      let inputStr = String(userInput).trim();

      console.log("Comparing OTPs - Server:", otpStr, "User Input:", inputStr);

      if (otpStr === inputStr) {
        flag = true;
        console.log("OTP verification successful!");
      } else {
        flag = false;
        console.warn(
          "OTP mismatch - Server OTP:",
          otpStr,
          "User entered:",
          inputStr,
        );
      }
    }

    return flag;
  };

  Submit_Form = async () => {
    this.phoneNumberError.html("");
    this.emailError.html("");
    prevPhoneNo = this.inputPhoneNumber.val();
    prevEmail = this.inputEmail1.val();
    $.ajax({
      type: "POST",
      url: baseURL + "api/Vendor/VerifyOTPUpdateDetails",
      // data : {
      //     "name" : phoneNumberInput,
      //     "category" : passwordInput
      //       },
      headers: { Authorization: X_API_KEY },

      data: this.basicDetailsAndAddressForm.serialize(),
      statusCode: {
        400: function () {
          alert("400 status code! user error");
        },
        500: function () {
          alert("500 status code! server error");
        },
      },
      success: this.Validate_Email,
      // error: function (res) {
      //
      //   this.phoneExists;
      // },
    });

    await this.UploadBusinessImages();
    // $.ajax({
    //   type: "POST",
    //   url: baseURL + "api/Vendor/documentUpload",
    //   data: {
    //     vendorDocumentArray: vendorDocumentArray,
    //   },
    //   success: function (res) {
    //     //
    //   },
    // });
    this.otpInputVerify.val("");
    this.otpError.html("");
    this.verifyOTPBtn.removeClass("d-none");
  };

  Validate_Email = () => {
    let userEmail = this.inputEmail1.val();
    $.ajax({
      type: "POST",
      url: baseURL + "api/ZeroBounce/update",
      data: {
        basicEmail: document.getElementById("inputEmail1").value,
      },
      headers: { Authorization: X_API_KEY },

      success: function (res) {},
    });
  };

  UploadBusinessImages = async () => {
    const imgPrevEle = document.getElementsByClassName("Businessimage-preview");
    const uploadPromises = [];

    for (var i = 1; i <= 3; i++) {
      const CurrentimgPrevEle = imgPrevEle[i - 1];
      if (!CurrentimgPrevEle) continue;

      const imageData = CurrentimgPrevEle.src;
      const regex = /^data:/;

      // Only upload if image data has been cropped/modified (base64)
      if (regex.test(imageData)) {
        const uploadPromise = new Promise((resolve, reject) => {
          $.ajax({
            type: "POST",
            url: baseURL + "api/Vendor/businessPhotoUpload",
            headers: { Authorization: X_API_KEY },
            data: {
              ProductImages: [
                {
                  imageFile: imageData,
                  imageNo: i,
                  imageName: "BusinessImage" + i,
                },
              ],
              productServiceName: "BusinessImage" + i,
            },
            success: (response) => {
              // Update the preview image with the new URL and a cache-buster
              const previewId = "inpBusinessImgPreview" + i;
              const previewImg = document.getElementById(previewId);
              if (previewImg) {
                const timestamp = new Date().getTime();
                previewImg.src = response + (response.includes("?") ? "&" : "?") + "t=" + timestamp;
              }
              resolve(response);
            },
            error: (err) => {
              console.error("Error uploading business image " + i, err);
              reject(err);
            },
          });
        });
        uploadPromises.push(uploadPromise);
      }
    }

    try {
      await Promise.all(uploadPromises);
      console.log("All business images uploaded successfully");
    } catch (error) {
      console.error("Error uploading one or more business images", error);
    }
  };

  doResendOTPAction = (e) => {
    e.preventDefault();
    this.doFormAction(e);
    $("#otpResendMsg").html("New OTP has been sent to you.");
    setTimeout(() => {
      $("#otpResendMsg").html("");
    }, 4000);
  };
}

